export default "__VITE_ASSET__6x3iH$OX__"